import { createResource, type RouteResource } from 'react-resource-router';

import { eocCommonResources } from '@atlassian/eoc-resources';
import { resources as scheduleCommonResources } from '@atlassian/eoc-schedule-common/resources';

import { getTeamIdFromContext } from '../../utils';
import { endpoints as editEndpoints } from '../endpoints/edit';
import type { ScheduleTimeTemplatesResponse } from '../endpoints/edit/types';
import { endpoints as listEndpoints } from '../endpoints/list';
import type { TeamScheduleListResponse } from '../endpoints/list/types';
import { endpoints as pageEndpoints } from '../endpoints/page';
import type { UiPreferencesResponse } from '../endpoints/page/types';
import { endpoints as sectionEndpoints } from '../endpoints/section';
import type { ScheduleRightsResponse } from '../endpoints/section/types';

const getSchedulesResource: RouteResource<TeamScheduleListResponse> = createResource({
	type: 'getSchedulesResource',
	getKey: () => 'getSchedulesResource',
	isBrowserOnly: true,
	getData: async (routerExtendedContext) =>
		listEndpoints.getScheduleList(getTeamIdFromContext(routerExtendedContext)),
});

const getUiPreferencesResource: RouteResource<UiPreferencesResponse> = createResource({
	type: 'getSchedulePreferencesResource',
	getKey: () => 'getSchedulePreferencesResource',
	isBrowserOnly: true,
	getData: async (routerExtendedContext) =>
		pageEndpoints.getUiPreferences(getTeamIdFromContext(routerExtendedContext)),
});

const getScheduleRightsResource: RouteResource<ScheduleRightsResponse> = createResource({
	type: 'getScheduleRightsResource',
	getKey: () => 'getScheduleRightsResource',
	isBrowserOnly: true,
	getData: async (routerExtendedContext) =>
		sectionEndpoints.getScheduleRights(getTeamIdFromContext(routerExtendedContext)),
});

const getScheduleTimeTemplatesResource: RouteResource<ScheduleTimeTemplatesResponse> =
	createResource({
		type: 'getScheduleTimeTemplatesResource',
		getKey: () => 'getScheduleTimeTemplatesResourceurce',
		isBrowserOnly: true,
		getData: async () => editEndpoints.getScheduleTimeTemplates(),
	});

const resources = [
	getSchedulesResource,
	getUiPreferencesResource,
	getScheduleRightsResource,
	getScheduleTimeTemplatesResource,
	...scheduleCommonResources,
	...eocCommonResources(),
];

export type {
	TeamScheduleListResponse,
	UiPreferencesResponse,
	ScheduleRightsResponse,
	ScheduleTimeTemplatesResponse,
};

export {
	getSchedulesResource,
	getUiPreferencesResource,
	getScheduleRightsResource,
	getScheduleTimeTemplatesResource,
	resources,
};
